import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as CoreActions from '@app/core/store/core.action';
import { selectCoreState, selectIsNavOpen, showErrorMessage } from '@app/core/store/core.selectors';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';

@Component({
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss']
})

export class MessageModalComponent implements OnInit {
  public title: string;
  public body: string;
  public show_upgrade: string;
  public upgradeMessage: string;
  
  constructor(
    private store$: Store,
    private _translation: TranslateService,
    private _matDialog: MatDialog,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  
  ngOnInit(): void {
    // this.store$.select(showErrorMessage).subscribe(errorMessage => {
    //   this.title = errorMessage?.title ?? '';
    //   this.body = errorMessage?.body ?? '';
    //   this.show_upgrade = errorMessage?.show_upgrade ?? '';
    // });

    this.title = this.data?.title ?? '';
    this.body = this.data?.body ?? '';
    this.show_upgrade = this.data?.show_upgrade ?? '';
  }

  public goToProfile() {
    this._matDialog.closeAll();
    this.router.navigate(['/profile']);

  }


}

